import {cn} from '@bem-react/classname';

export const cnObjectOption = cn('ObjectOption');
